<template>
  <div class="core_wrap  hidden-xs-only">
    <div class="core_title">产品展示</div>
    <el-tabs
        tab-position="left"
        class="core_tabs"
        v-loading="loading"
    >
      <el-tab-pane
          v-for="(item, index) in coresList"
          :label="item.name"
          :key="index"
      >
        <!-- 底层背景图 -->
        <img
            class="base_img"
            src="../../../assets/img/home/productshow/project_down.png"
            alt="产品背景"
            loading="lazy"
        />

        <!-- 上层轮播图（核心改造：替换单张图片为轮播） -->
        <div class="product-carousel-wrap">
          <!-- 空数据提示 -->
          <div class="carousel-empty" v-if="!item.second || !item.second.length">
            暂无轮播图片
          </div>
          <!-- 轮播组件 -->
          <el-carousel
              v-else
              class="product-carousel"
              autoplay
              loop
              arrow="hover"
          >
            <el-carousel-item v-for="(imgItem, imgIndex) in item.second" :key="imgIndex">
              <img
                  class="carousel-img"
                  :src="getImgUrl(imgItem.src)"
                  :alt="`${item.name}-轮播图${imgIndex+1}`"
                  loading="lazy"
                  @click="handleImgClick(imgItem)"
                  @error="handleImgError($event)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getProduct } from "@/api/home";

export default {
  name: "ProductShow",
  data() {
    return {
      loading: false, // 加载状态
      coresList: [],
      // 图片加载失败兜底图
      fallbackImg:  require('@/assets/img/home/productshow/banner.png'),
    };
  },
  created() {
    this.fetchProductList();
  },
  methods: {
    /**
     * 请求后端Java接口，获取产品列表
     */
    async fetchProductList() {
      try {
        this.loading = true;
        const res = await getProduct();
        if (res.code === 200) {
          // 数据格式化：确保second数组存在，避免报错
          this.coresList = (res.data || []).map(item => ({
            ...item,
            second: item.second || [] // 兜底空数组
          }));
        } else {
          this.$message.error(res.msg || "获取产品列表失败");
          this.coresList = [];
        }
      } catch (error) {
        console.error("产品列表请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.coresList = [];
      } finally {
        this.loading = false;
      }
    },
    /**
     * 处理图片URL（兼容绝对/相对路径）
     * @param {string} src 图片地址
     * @returns {string} 完整URL
     */
    getImgUrl(src) {
      if (!src) return this.fallbackImg;
      // 绝对路径直接返回，相对路径拼接后端域名（根据实际配置调整）
      return src.startsWith("http") ? src : process.env.VUE_APP_BASE_API + src;
    },
    /**
     * 图片加载失败兜底
     * @param {Event} e 错误事件
     */
    handleImgError(e) {
      e.target.src = this.fallbackImg;
    },
    /**
     * 处理轮播图点击跳转
     * @param {Object} imgItem 图片项（包含url、urlType）
     */
    handleImgClick(imgItem){
      const { url, urlType } = imgItem;
      try {
        // 1. 外部链接：新窗口打开，添加安全属性
        if (urlType === '1') {
          // 校验URL合法性（基础校验）
          // if (!/^https?:\/\//.test(url)) {
          //   this.$message.warning("外部链接格式错误，请检查");
          //   return;
          // }
          window.open(url, '_blank', 'noopener,noreferrer');
        }
        // 2. 内部路由：项目内跳转
        else if (urlType === '2') {
          this.$router.push({
            path: '/productDetail',
            query: {
              productId: imgItem.id,
              type: 'product'
            }
          });
        }
        // 其他类型：提示无跳转逻辑
        else {
          this.$message.error("暂无跳转链接");
        }
      } catch (error) {
        console.error("图片跳转失败：", error);
        this.$message.error("跳转失败，请稍后重试");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
// 基础变量
$primary-color: #ce636c;
$text-color: #203040;
$bg-color: #f8f8f8ff;
$empty-color: #999;
$carousel-indicator-color: #fff;
$carousel-indicator-active-color: $primary-color;

.core_wrap {
  position: relative;
  width: 100%;
  min-height: 800px;
  text-align: center;
  flex-wrap: wrap;
  background-color: $bg-color;
  box-sizing: border-box;
  padding: 0 20px; // 防贴边

  // 标题样式
  .core_title {
    color: $text-color;
    font-size: 40px;
    font-weight: bold;
    text-align: left;
    padding: 150px 0 0 160px;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      padding: 80px 0 0 20px;
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      font-size: 2rem;
      padding: 100px 0 0 80px;
    }
  }

  // Tab容器
  .core_tabs {
    font-size: 32px;
    padding-left: 140px;
    padding-top: 95px;


    @media screen and (max-width: 768px) {
      padding-left: 20px;
      padding-top: 40px;
      ::v-deep .el-tabs__nav-scroll{
        padding-top: 10px;
      }
      ::v-deep .el-tabs--left {
        .el-tabs__content {
          margin-left: 0 !important; // 移动端Tab横向排列
        }
        .el-tabs__nav {
          float: none !important;
          margin-bottom: 20px;
        }
      }
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      padding-left: 80px;
      padding-top: 60px;
    }
  }

  // 底层背景图
  .base_img {
    width: 1150px;
    height: 650px;
    margin: 100px 0 0 35px;
    display: block;
    float: right;
    z-index: 1;
    position: relative;

    @media screen and (max-width: 768px) {
      width: 100%;
      height: auto;
      margin: 20px 0 0 0;
      float: none;
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      width: 80%;
      height: auto;
      margin: 50px 0 0 0;
      float: right;
    }
  }

  // 轮播容器
  .product-carousel-wrap {
    position: absolute;
    right: 130px;
    width: 1200px;
    height: 700px;
    z-index: 2; // 确保轮播在底层图上方
    //opacity: 0.8;
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      height: 500px;
      width: calc(100% - 200px); // 适配平板宽度，避免溢出
      top: 0; // 【关键修改】设置top:0，强制轮播图顶端对齐父容器
      margin-top: 0; // 清除可能存在的margin-top干扰
    }

    // 空数据提示
    .carousel-empty {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $empty-color;
      font-size: 18px;
    }

    // 轮播组件核心样式
    .product-carousel {
      width: 100%;
      height: 100%;

      // 轮播图片
      .carousel-img {
        width: 100%;
        //height: 100%;
        object-fit: contain; // 保证图片完整显示
        object-position: center; // 图片居中显示
        cursor: pointer;
        background-color: #f5f5f5; // 增加背景色，避免空白
      }

      // 轮播指示器样式（穿透修改）
      ::v-deep .el-carousel__indicator {
        .el-carousel__indicator-button {
          background-color: rgba(255, 255, 255, 0.5);
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }
      }
      ::v-deep .el-carousel__indicator.is-active {
        .el-carousel__indicator-button {
          background-color: $carousel-indicator-active-color;
        }
      }
      ::v-deep .el-carousel__container{
        height: 700px;
        @media screen and (min-width: 769px) and (max-width: 1200px) {
          height: 500px; // 确保容器高度同步
        }
      }

      // 轮播箭头样式（穿透修改）
      ::v-deep .el-carousel__arrow {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.3);
        color: #fff;
        &:hover {
          background-color: $primary-color;
        }
      }
    }

    // 响应式适配
    @media screen and (max-width: 768px) {
      position: relative;
      right: 0;
      width: 100%;
      height: auto;
      min-height: 300px;
      margin-top: -70%; // 调整叠层位置
      //opacity: 0.9;
      .product-carousel {
        height: 300px;
      }
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      right: 50px;
      width: 80%;
      height: 500px; // 固定高度500px
      top: 0; // 【关键修改】再次强调top:0，确保顶端对齐
      margin-top: 0; // 清除margin干扰
      .product-carousel {
        height: 500px; // 轮播组件高度同步
      }
    }
  }
}

// Tab样式穿透修改
::v-deep {
  .el-tabs__item {
    font-size: 20px !important;
    text-align: left !important;
    padding-bottom: 55px !important;

    @media screen and (max-width: 768px) {
      padding-bottom: 20px !important;
      font-size: 16px !important;
      margin-right: 15px;
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      font-size: 18px !important;
      padding-bottom: 30px !important;
    }
  }

  // 移除Tab下划线
  .el-tabs__nav-wrap::after {
    position: static !important;
  }

  // 选中Tab下划线颜色
  .el-tabs__active-bar {
    background-color: #f6f6f6;
  }

  // Tab选中态
  .el-tabs__item.is-active {
    color: $primary-color !important;
    opacity: 1;
  }

  // Tab悬浮态
  .el-tabs__item:hover {
    color: $primary-color !important;
    cursor: pointer;
    opacity: 1;
  }
}
</style>